export enum HypeAuditorGenderType {
  MALE = 'M',
  FEMALE = 'F'
}
export class DemographicHypeAuditor {
  username: string;
  genders: HypeAuditorGender[];
  countries: HypeAuditorCountry[] = [];
  audienceInterest: [[string, number]];
  audienceType: AudienceType;
  authenticEngagement: AudienceType;
  languages: HypeAuditorLanguage[] = [];
  cities: HypeAuditorCity[] = [];
  demographyByAge: HAGenderDemographyByAge[] = [];
  isOutdated: boolean;
  isNew?: boolean;
}

export class HypeAuditorGender {
  gender: HypeAuditorGenderType;
  value: number;
}

export class HAGenderDemographyByAge {
  gender: string;
  value: number;
  by_age_group: Array<HAAgeGroupItem> = [];
}

export class HAAgeGroupItem {
  group: string;
  value: number;
}

export class HypeAuditorCountry {
  name: string;
  code?: string;
  value: number;
}

export class AudienceType {
  real: number;
  susp: number;
  infs: number;
  mass: number;
}

export class HypeAuditorLanguage {
  name?: string;
  code: string;
  value: number;
}

export class HypeAuditorCity {
  name: string;
  value: number;
}



// WEBPACK FOOTER //
// ./src/models/demographic/demographic-hype-auditor.ts